export default "__VITE_ASSET__9laBa9qZvRUo4T73QN$13Q__";